export default "__VITE_ASSET__Cus$GPLu__"